import { useMutation, useQuery } from "@apollo/client";
import { Button, message, Skeleton, Switch, Tag } from "antd";
import React from "react";
import { UPDATE_LEAD_CAMPAIGN_CONVERSATION } from "../../../graphql/mutation/mutation";
import { GET_CAMPAIGN_BY_LEAD } from "../../../graphql/query";
import { closeDialog } from "../../../library/helpers";

const CampaignToggle = props => {
  const { selectedLead } = props;
  const { data: campaignData, loading: campaignByLeadLoader } = useQuery(GET_CAMPAIGN_BY_LEAD, {
    fetchPolicy: "network-only",
    variables: {
      leadId: selectedLead.id,
    },
  });
  const [updateLeadCampaignToggle, { loading: modifyLeadCampaignConversationLoader }] = useMutation(
    UPDATE_LEAD_CAMPAIGN_CONVERSATION
  );
  const handleCampaignToggle = async (campaignId, isDisabled) => {
    const payload = {
      leadId: selectedLead.id,
      isDisable: isDisabled,
      campaignIds: [campaignId],
    };
    const res = await updateLeadCampaignToggle({
      variables: payload,
    });
    if (res.data.modifyLeadCampaignConversation.statusCode === 200) {
      message.success(res.data.modifyLeadCampaignConversation.message);
      closeDialog("campaignToggle");
    } else {
      message.error(res.data.modifyLeadCampaignConversation.message);
    }
  };
  return (
    <>
      {campaignByLeadLoader ? (
        <Skeleton active paragraph={{ rows: 3 }} avatar />
      ) : (
        <div>
          <div className="flex-col-centered gap-1 overflow-auto">
            {campaignData?.getCampaignByLead?.data.map((item, index) => {
              return (
                <div
                  className="p-2 flex-col-centered gap-1.5 items-start rounded-[4px] border-[1px] border-solid border-gray-300"
                  key={index}
                >
                  <div className="flex-row-centered items-center w-full justify-between">
                    <span>{item.name}</span>
                    <Switch
                      loading={modifyLeadCampaignConversationLoader}
                      onChange={checked => handleCampaignToggle(item.id, !checked)}
                    />
                  </div>
                  <Tag>{item.activeInd}</Tag>
                </div>
              );
            })}
          </div>
          <span className="text-sm text-gray-600">
            Turning off campaign/s will stop sending the campaign messages for this lead.
          </span>
        </div>
      )}
      <div className="flex-row-centered justify-end">
        <Button onClick={() => closeDialog("campaignToggle")}>Close</Button>
      </div>
    </>
  );
};

export default CampaignToggle;
